import { Component, OnInit, ElementRef } from '@angular/core';
import {  ViewChild } from '@angular/core';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';
@Component({
  selector: 'app-front-end-outlook-general',
  templateUrl: './front-end-outlook-general.component.html',
  styleUrls: ['./front-end-outlook-general.component.css']
})
export class FrontEndOutlookGeneralComponent implements OnInit {
  roomevents:RoomEvents[];
  roomEvents_Outlook;
  meetingrooms:MeetingRooms[];
  public room_id_from_url:string;
  public event_array:Event_array[];
  //public Event_name:string[];
  public Event_start_time:string[];
  public Event_end_time:string[];
  public Today_date:string;
  public Clock_date:string;
  // public Event_end_date:string;
  public Event_Host_Name:string[];
  public Event_Logo_Path:string;
  public Event_Attendants_Array:string[];
  public RoomOccupied:boolean;
  public Event_room_name:string;

  constructor(private route: ActivatedRoute,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) {
    setInterval(() => {
      this.refreshData();
      this.getOutlookRoomMeetings();
    }, 15000);

   }

  ngOnInit() {
       this.refreshData();
        this.getOutlookRoomMeetings();
        this.RoomOccupied=false;
  }

  format_time= (date_obj) => {
 // formats a javascript Date object into a 12h AM/PM time string
 var hour = date_obj.getHours();
 var minute = date_obj.getMinutes();
 var amPM = (hour > 11) ? "PM" : "AM";
 if(hour > 12) {
   hour -= 12;
 } else if(hour == 0) {
   hour = "12";
 }
 if(minute < 10) {
   minute = "0" + minute;
 }
 return hour + ":" + minute +" "+ amPM;
}

// Accepts a Date object or date string that is recognized by the Date.parse() method
getDayOfWeek =(date) => {
var dayOfWeek = new Date(date).getDay();
return isNaN(dayOfWeek) ? null : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
}

   clickedactive = (index)=>{

  }

  sortByKey(array, key) {
      return array.sort(function(a, b) {
          var x = a[key]; var y = b[key];
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
  }

  getOutlookRoomMeetings = () =>{
    let room_id_from_url = this.route.snapshot.paramMap.get('id');
    this.getdataService.getAccessToken(room_id_from_url).subscribe((room_data) => {
      //console.log(room_data);
      this.getdataService.getMeetingsUsingAccessToken(room_data[0].graph_access_token,  room_data[0].graph_user_name, room_data[0].room_outlook_ID).subscribe((meetings_data) => {
      
          // //console.log(this.roomEvents_Outlook)
          //console.log(meetings_data.success);
          if(typeof meetings_data.success ==='undefined' ){
            this.roomEvents_Outlook = meetings_data.value
            
          }else{
            this.getdataService.renewAccessToken(room_data[0].graph_refresh_token, room_data[0]._id).subscribe((data) => {
              //console.log(data);
          },err=>{
            //console.log("couldn't renew token");
            return false;
          })
          }
          ////console.log(this.roomEvents_Outlook)
         // this.roomEvents_Outlook =[]
      },
      err=>{
        //console.log("couldn't get room events");
        return false;
      });
      
    },
    err=>{
      //////console.log(err);
      return false;
    });


  }

  callFunction(id) {

      //document.getElementById('event_list_0').setAttribute( "class", "event_list_active" );
      ////console.log(id+"is active");
      var d = new Date();
      var currentDate = d.getTime();
      ////console.log(this.event_array);
      ////console.log(currentDate);
      for(let i=0; i< this.event_array.length; i++)
      {
        if(this.event_array[i].Event_start_time_number<currentDate && this.event_array[i].Event_end_time_number>currentDate)
        {
          // $('.box2').animate({
          //     scrollTop: $('#event_list_'+i).offset().top
          // }, 000);
          $('.box2').scrollTo('#event_list_'+i);
          this.RoomOccupied=true;

          //////image file path////////
          //alert("we have event now");
          document.getElementById('event_list_'+i).setAttribute( "class", "event_list_active" );
          ////console.log("we have event now");
          if(this.event_array[i].Event_logo_path_onarray == '')
          {
            //////console.log("there is no logos");
            this.Event_Logo_Path = this.meetingrooms[0].room_default_logo_path;
            // this.Event_Logo_Path = this.event_array[i].Event_logo_path_onarray;
          }else{

            this.Event_Logo_Path = this.event_array[i].Event_logo_path_onarray;
            ////console.log("LOGO path is" +this.Event_Logo_Path);
          }
          break;
        }else{
            this.RoomOccupied=false;
            this.Event_Logo_Path = this.meetingrooms[0].room_default_logo_path;
            ////console.log("No event now");
            ////console.log("LOGO path is" +this.Event_Logo_Path);
        }

      }
      ////console.log(this.RoomOccupied);
  }
   refreshData = ()=>{
     this.room_id_from_url = this.route.snapshot.paramMap.get('id');
     this.getdataService.getMeetingRoombyID(this.room_id_from_url).subscribe((meetingrooms) => {
       this.meetingrooms=  meetingrooms;
       this.Event_room_name=  this.meetingrooms[0].room_name;
     },
     err=>{
       //////console.log(err);
       return false;
     });

     ////Date////
     var date_now = new Date();
      var dd = date_now.getDate();

     var mm = date_now.getMonth() + 1; // 0 is January, so we must add 1
     var yyyy = date_now.getFullYear();
     var day = this.getDayOfWeek(date_now);
     // &nbsp;

     this.Today_date = day+" "+dd+"/"+mm+"/"+yyyy;

     this.Clock_date = this.format_time(date_now).toString();


     this.getdataService.getEventByRoomID(this.room_id_from_url).subscribe((roomevents) => {
       this.roomevents=  roomevents;
       var d = new Date();
       var currentDate = d.getTime();
       var currentDate_start = d.setHours(0);
       var currentDate_start = d.setMinutes(0);
       var currentDate_start = d.setSeconds(0);
       var currentDate_end = d.setHours(23);
       var currentDate_end = d.setMinutes(59);
       var currentDate_end = d.setSeconds(59);

       ////console.log("loggin start and end time");
       ////console.log(currentDate_start+" --- "+currentDate_end);
       var x=0;
       this.event_array=[];


         for(var i=0; i<this.roomevents.length; i++)
         {
           var startDate = new Date(this.roomevents[i].event_start_time).getTime() + (d.getTimezoneOffset() * 60000);
           var endDate = new Date(this.roomevents[i].event_end_time).getTime() + (d.getTimezoneOffset() * 60000);
           ////console.log("start date of the event in general:");
           ////console.log(startDate);
           if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
           {

             /////event name/////
             ////console.log("event name");
             ////console.log(this.roomevents[i].event_name);
             ////console.log(x);
             this.event_array[x]={Event_id:x,Event_name:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:'',Event_logo_path_onarray:''}
             this.event_array[x].Event_name=this.roomevents[i].event_name ;
              var  date = new Date(startDate);
             this.event_array[x].Event_start_time=this.format_time(date).toString();
             this.event_array[x].Event_start_time_number = startDate;
             date = new Date(endDate);
             this.event_array[x].Event_end_time=this.format_time(date).toString() ;
             this.event_array[x].Event_end_time_number = endDate;
             ////console.log(this.event_array[x].Event_end_time);
             this.event_array[x].Event_Host_Name=this.roomevents[i].event_host_name;
             this.event_array[x].Event_logo_path_onarray =  this.roomevents[i].event_logo_path;
             x++;
             //////current meeting fetch////////

           }
         }

         //sorting of the array
        this.event_array = this.sortByKey(this.event_array,'Event_start_time_number');
        for(let i=0; i<this.event_array.length; i++)
        {
          this.event_array[i].Event_id = i;
        }

        if(this.event_array.length <1)
        {
          ////console.log("no events today")
          //////console.log("no event now");
         // this.Event_name = [] ;
         this.event_array[0]={Event_id:0,Event_name:'No meeting reserved today',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:'',Event_logo_path_onarray:''}

          //////console.log(this.Event_Logo_Path);
          this.Event_Logo_Path = this.meetingrooms[0].room_default_logo_path;
        }

       //////console.log( document.getElementById("event_list_0"));
       // if(document.getElementById("event_list_0") !== null )
       // {
       //   // $("#event_list_0").removeClass("event_list");
       //   // $("#event_list_0").addClass('event_list_active');
       //   // alert('ha');
       //   this.clickedactive(0);
       //  // $('#event_list_0').removeClass('event_list');
       //  // $('#event_list_0').addClass('event_list_active');
       //  // document.getElementById("event_list_0").className += "event_list_active";
       //   //////console.log(document.getElementById("event_list_0"));
       // }

       //////console.log('events in stackl: ' +this.roomevents.length);


       // if(this.Event_name == '')
       // {
       //   this.Event_name = 'currently no event' ;
       // //  this.Event_room_name = 'room name';
       // }

     },
   err=>{
     //////console.log(err);
     return false;
   });





   }
}


interface MeetingRooms{
  _id:number,
  room_name:string,
  room_place:string,
  room_default_logo:string,
  room_default_logo_path:string,
  room_type:string,
  room_floor_number:string,
  room_slider_ID:string
}

interface RoomEvents{
  _id:number,
  event_name:string,
  event_room:string,
  event_room_id:string,
  event_place:string,
  event_start_time:Date,
  event_start_time_readable:string,
  event_end_time_readable:string,
  event_end_time:Date,
  event_logo:string,
  event_logo_path:string,
  event_host_name:string,
  event_attendants:string[]
}

interface Event_array{
  Event_id:number,
  Event_name:string,
  Event_start_time:string,
  Event_start_time_number:number,
  Event_end_time:string,
  Event_end_time_number:number,
  Event_Host_Name:string,
  Event_logo_path_onarray:string
}



// WEBPACK FOOTER //
// ./src/app/components/front-end-outlook-general/front-end-outlook-general.component.ts